import { useState, useEffect } from 'react';
import axios from 'axios';
import LeftNav from '../components/Leftnav';
import TopBar from '../components/Topbar';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import '../css/Addacgroup.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useUser, useToken } from '../components/auth';
import InfoIcon from '@mui/icons-material/Info';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { useNavigate } from 'react-router';
import moment from 'moment';
import writeXlsxFile from 'write-excel-file';
import GetAppIcon from '@mui/icons-material/GetApp';

export default function Ration() {
  const navigate = useNavigate();
  const url = process.env.REACT_APP_BASE_URL;
  const [token] = useToken();
  const user = useUser();
  const { id } = user;
  const [locations, setLocations] = useState([]);
  const [locationNew, setLocationNew] = useState(0);
  const [searchMessage, setSearchMessage] = useState('');
  const [workers, setWorkers] = useState([]);
  const [worker, setWorker] = useState(0);
  const [userSearch, setUserSearch] = useState(0);
  const [userDataa, setUserDataa] = useState([]);

  useEffect(() => {
    const userData = async () => {
      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/signup`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setUserDataa(data.getUser.filter((loc) => loc.type !== ''));
      } catch (error) {
        console.log(error);
      }
    };
    userData();
  }, [token, url]);

  function handleSaerchUser(event) {
    setUserSearch(event.target.value);
  }
  useEffect(() => {
    async function locationsList() {
      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/ration/workers`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setWorkers(data);
      } catch (error) {
        console.log(error);
      }
    }
    locationsList();
  }, [token, url]);

  const [wo, setWo] = useState(workers);

  useEffect(() => {
    async function locationsList() {
      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/signup/locations`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setLocations(data);
      } catch (error) {
        console.log(error);
      }
    }
    locationsList();
  }, [token, url]);

  function handleLocationChanges(event) {
    setLocationNew(event.target.value);
    setWorker(0);
    const locationWorkers = workers.workersData.filter(
      (d) => d.location === event.target.value
    );

    setWo(locationWorkers);
  }

  function handleWorkerChanges(event) {
    setWorker(event.target.value);
  }

  const [message, setMessage] = useState('');

  // Getting existing users
  const [garageDataa, setGarageDataa] = useState([]);
  useEffect(() => {
    const userData = async () => {
      const time = moment().format().substring(0, 10);
      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/ration?sdate=${time}&edate=${time}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setGarageDataa(data);
      } catch (error) {
        console.log(error);
      }
    };
    userData();
  }, [token, url]);

  // searching

  async function search() {
    setGarageDataa([]);
    const sdate = document.querySelector('#s-date').value;
    const edate = document.querySelector('#e-date').value;
    if (sdate === '' || edate === '') {
      setSearchMessage('Please select start date and end date');
      document.querySelector('#searchMessage').style.color = 'red';
    } else {
      setSearchMessage('Tegereza.....');
      document.querySelector('#searchMessage').style.color = 'blue';

      try {
        const config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${url}/ration?sdate=${sdate}&edate=${edate}&user=${userSearch}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        };

        const { data } = await axios.request(config);
        setGarageDataa(data);
        if (data.rationsData.length !== 0) {
          setSearchMessage('');
        } else {
          setSearchMessage(`No data found from ${sdate} to ${edate}`);
          document.querySelector('#searchMessage').style.color = 'green';
        }
      } catch (error) {
        console.log(error);
        setSearchMessage('Error while retrieving data');
        document.querySelector('#searchMessage').style.color = 'red';
      }
    }
  }

  // Adding garages data

  async function saveRation() {
    const datee = document.querySelector('#date').value;
    const amount = document.querySelector('#amount').value;

    if (
      worker === '' ||
      worker === 0 ||
      amount === '' ||
      locationNew === '' ||
      locationNew === 0
    ) {
      setMessage('Please fill out all the required fields');
      document.querySelector('#message').style.color = 'red';
    } else {
      setMessage('Tegereza.....');
      document.querySelector('#message').style.color = 'blue';
      try {
        const datass = JSON.stringify({
          datee: datee,
          umukozi: worker,
          amount: amount,
          location: locationNew,
          user: id,
        });
        const config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${url}/ration`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          data: datass,
        };

        const { data } = await axios.request(config);
        if (data.message === 'Ration data added') {
          document.querySelector('#date').value = '';
          document.querySelector('#amount').value = '';
          setMessage(data.message);
          setLocationNew(0);
          setWorker(0);
          document.querySelector('#message').style.color = 'green';
        }
        setMessage(data.message);
      } catch (error) {
        console.log(error);
        setMessage(`Ntibishoboye gukunda`);
        document.querySelector('#message').style.color = 'red';
      }
    }
  }

  //export button

  let total = 0;
  let displayData = [];

  if (Object.keys(garageDataa).length !== 0) {
    let i = 0;
    displayData = garageDataa.rationsData.map((row) => {
      i++;
      total += parseInt(row.amount);
      const ti = row.time
        .toLocaleString('en-GB', {
          timeZone: 'Africa/Kigali',
        })
        .substring(0, 10);

      return { ...row, time: ti, i };
    });
  }
  // preparing data for export

  const HEADER_ROW = [
    {
      value: 'No',
      fontWeight: 'bold',
    },
    {
      value: 'UMUKOZI',
      fontWeight: 'bold',
    },
    {
      value: 'Amount',
      fontWeight: 'bold',
    },
    {
      value: 'Location',
      fontWeight: 'bold',
    },
    {
      value: 'Account',
      fontWeight: 'bold',
    },
    {
      value: 'Bank',
      fontWeight: 'bold',
    },
    {
      value: 'DATE',
      fontWeight: 'bold',
    },
  ];
  //datas
  let rowss = [];
  rowss = displayData.map((row) => {
    return [
      {
        type: Number,
        value: row.i,
      },
      {
        value: row.umukozi,
      },
      {
        value: row.amount,
      },
      {
        value: row.location_name,
      },
      {
        value: row.account,
      },
      {
        value: row.bank,
      },
      {
        value: row.time,
      },
    ];
  });

  //totals
  const TOTAL_ROW = [
    {
      value: '',
      fontWeight: 'bold',
    },
    {
      value: 'TOTAL',
      fontWeight: 'bold',
    },
    {
      value: total,
      fontWeight: 'bold',
    },
    {
      value: '',
      fontWeight: 'bold',
    },
    {
      value: '',
      fontWeight: 'bold',
    },
    {
      value: '',
      fontWeight: 'bold',
    },
    {
      value: '',
      fontWeight: 'bold',
    },
  ];

  const data = [HEADER_ROW, ...rowss, TOTAL_ROW];
  async function exportData(d) {
    await writeXlsxFile(d, {
      fileName: 'Ration-abakozi.xlsx',
    });
  }

  // displaying garages datas

  return (
    <div className="App">
      <div className="left-side">
        <LeftNav />
      </div>
      <div className="right-side">
        <div>
          <TopBar page="Ration" />
        </div>
        {/* Tab here */}
        <br />
        <Tabs
          defaultActiveKey="ration"
          id="uncontrolled-tab-example"
          className="mb-2"
        >
          <Tab eventKey="ration" title="Ration">
            <div className="cars-add-btn-dv">
              <FormControl sx={{ m: 1, width: '20%', marginTop: 2.5 }}>
                <InputLabel id="demo-simple-select-label">Location</InputLabel>
                <Select
                  id="location_search"
                  label="Location*"
                  value={userSearch}
                  onChange={handleSaerchUser}
                >
                  <MenuItem key={0} value={0}>
                    All locations
                  </MenuItem>
                  {userDataa.length !== 0 &&
                    userDataa.map((row) => (
                      <MenuItem key={row.id} value={row.id}>
                        {row.fname} {row.lname} - {row.location_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <input
                name="s-date"
                id="s-date"
                style={{ height: '40px', marginTop: '30px' }}
                type="date"
              />
              <span style={{ width: '30px' }}> </span>
              <input
                name="e-date"
                id="e-date"
                style={{ height: '40px', marginTop: '30px' }}
                type="date"
              />
              <span style={{ width: '10px' }}> </span>
              <Button
                onClick={search}
                style={{ height: '40px', marginTop: '30px' }}
                variant="contained"
              >
                SEARCH
              </Button>
            </div>
            <div style={{ marginLeft: '20px' }}>
              <p id="searchMessage">{searchMessage}</p>
            </div>
            {Object.keys(garageDataa).length !== 0 && (
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead style={{ background: 'black' }}>
                    <TableRow>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>No</h6>
                      </TableCell>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Umukozi</h6>
                      </TableCell>

                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Amount</h6>
                      </TableCell>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Location</h6>
                      </TableCell>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Account</h6>
                      </TableCell>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Bank</h6>
                      </TableCell>
                      <TableCell>
                        <h6 style={{ color: '#fff' }}>Date</h6>
                      </TableCell>
                      <TableCell>
                        <h6>More</h6>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {displayData.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell>{row.i}</TableCell>
                        <TableCell>{row.umukozi}</TableCell>
                        <TableCell>{row.amount}</TableCell>
                        <TableCell>{row.location_name}</TableCell>
                        <TableCell>{row.account}</TableCell>
                        <TableCell>{row.bank}</TableCell>
                        <TableCell>
                          {row.time
                            .toLocaleString('en-GB', {
                              timeZone: 'Africa/Kigali',
                            })
                            .substring(0, 10)}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            onClick={() =>
                              navigate('/rationdata', { state: { row } })
                            }
                            startIcon={<InfoIcon />}
                          >
                            More
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <TableCell></TableCell>
                      <TableCell>Total</TableCell>
                      <TableCell>
                        {new Intl.NumberFormat().format(total)}
                      </TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    {Object.keys(garageDataa).length === 0 && (
                      <p>Loading........</p>
                    )}
                  </TableBody>
                </Table>
                <Button
                  variant="outlined"
                  onClick={() => exportData(data)}
                  startIcon={<GetAppIcon />}
                >
                  Export data
                </Button>
              </TableContainer>
            )}
          </Tab>
          <Tab eventKey="add" title="Add ration">
            {/*Add user here */}
            <Box
              component="form"
              sx={{
                '& .MuiTextField-root': {
                  m: 1,
                  width: '30ch',
                  marginTop: '20px',
                },
              }}
              noValidate
              autoComplete="off"
            >
              <div>
                <FormControl sx={{ m: 1, minWidth: 300, marginTop: 2.5 }}>
                  <InputLabel id="demo-simple-select-label">
                    Location*
                  </InputLabel>
                  <Select
                    id="location"
                    label="Location*"
                    value={locationNew}
                    onChange={handleLocationChanges}
                  >
                    <MenuItem key={0} value={0}>
                      <span>Hitamo Location yumukozi</span>
                    </MenuItem>
                    {locations.length !== 0 &&
                      locations.locationLists.map((loc) => (
                        <MenuItem key={loc.id} value={loc.id}>
                          {loc.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <TextField id="date" type="date" defaultValue="" />
              </div>
              <div></div>
              <div>
                <FormControl
                  sx={{
                    m: 1,
                    minWidth: 300,
                    marginTop: 2.5,
                  }}
                >
                  <InputLabel id="demo-simple-select-label">
                    Umukozi*
                  </InputLabel>
                  <Select
                    id="umukozi"
                    label="Umukozi*"
                    value={worker}
                    onChange={handleWorkerChanges}
                  >
                    <MenuItem key={0} value={0}>
                      <span style={{ color: 'red' }}>Hitamo Umukozi</span>
                    </MenuItem>
                    {wo.length !== 0 &&
                      wo.map((loc) => (
                        <MenuItem key={loc.id} value={loc.id}>
                          {loc.names}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <TextField
                  id="amount"
                  label="Amount*"
                  type="number"
                  defaultValue=""
                />
              </div>

              <p style={{ marginLeft: '15%' }} id="message">
                {message}
              </p>
              <div style={{ marginLeft: '20%', marginTop: '2%' }}>
                <Button variant="contained" onClick={saveRation}>
                  Save
                </Button>
              </div>
            </Box>

            {/* End of add a user */}
          </Tab>
        </Tabs>
        {/* Tabs ends here */}
      </div>
    </div>
  );
}
